import { render } from "./Shop.vue?vue&type=template&id=73b29f81&scoped=true&ts=true&lang=pug"
import script from "./Shop.vue?vue&type=script&lang=ts"
export * from "./Shop.vue?vue&type=script&lang=ts"

import "./Shop.vue?vue&type=style&index=0&id=73b29f81&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b29f81"]])

export default __exports__